import React, { useMemo, useState } from 'react'
import { exportFinance } from '../../api.js'
import FinanceNav from './FinanceNav.jsx'

function isoDate(d) {
  const dt = d instanceof Date ? d : new Date(d)
  if (Number.isNaN(dt.getTime())) return ''
  return dt.toISOString().slice(0, 10)
}
function startOfMonth(now = new Date()) {
  return new Date(now.getFullYear(), now.getMonth(), 1)
}
function endOfMonth(now = new Date()) {
  return new Date(now.getFullYear(), now.getMonth() + 1, 0)
}

export default function FinanceExport() {
  const now = useMemo(() => new Date(), [])
  const [from, setFrom] = useState(isoDate(startOfMonth(now)))
  const [to, setTo] = useState(isoDate(endOfMonth(now)))
  const [format, setFormat] = useState('csv')
  const [type, setType] = useState('summary')
  const [busy, setBusy] = useState(false)

  async function handleExport() {
    setBusy(true)
    try {
      await exportFinance({ from, to, type, format })
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="p-6 space-y-6 min-h-screen">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">📦 Exports Finance</h1>
        <p className="text-sm text-slate-500 mt-1">
          Exporte des données “compta” propres pour ton comptable (CSV aujourd’hui, PDF/Excel ensuite).
        </p>
      </div>

      <FinanceNav />

      <div className="bg-white rounded-xl p-4 shadow-sm border border-slate-200">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-3 items-end">
          <div>
            <label className="text-xs text-slate-500 block mb-1 font-medium">Du</label>
            <input
              type="date"
              value={from}
              onChange={(e) => setFrom(e.target.value)}
              className="border border-slate-200 px-3 py-2 rounded-lg w-full focus:ring-2 focus:ring-slate-300 focus:border-slate-400"
            />
          </div>

          <div>
            <label className="text-xs text-slate-500 block mb-1 font-medium">Au</label>
            <input
              type="date"
              value={to}
              onChange={(e) => setTo(e.target.value)}
              className="border border-slate-200 px-3 py-2 rounded-lg w-full focus:ring-2 focus:ring-slate-300 focus:border-slate-400"
            />
          </div>

          <div>
            <label className="text-xs text-slate-500 block mb-1 font-medium">Type</label>
            <select
              value={type}
              onChange={(e) => setType(e.target.value)}
              className="border border-slate-200 px-3 py-2 rounded-lg w-full bg-white"
            >
              <option value="summary">Synthèse</option>
              <option value="journal">Journal</option>
              <option value="trial-balance">Balance</option>
              <option value="accounts">Plan de comptes</option>
              <option value="profit-loss">Compte de résultat</option>
              <option value="cashflow">Trésorerie</option>
            </select>
          </div>

          <div>
            <label className="text-xs text-slate-500 block mb-1 font-medium">Format</label>
            <select
              value={format}
              onChange={(e) => setFormat(e.target.value)}
              className="border border-slate-200 px-3 py-2 rounded-lg w-full bg-white"
            >
              <option value="csv">CSV</option>
              <option value="pdf">PDF</option>
              <option value="xlsx" disabled>Excel (bientôt)</option>
            </select>
          </div>
        </div>

        <div className="mt-4">
          <button
            type="button"
            onClick={handleExport}
            disabled={busy || !from || !to}
            className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50 font-semibold"
          >
            {busy ? 'Export…' : '⬇️ Lancer export'}
          </button>
        </div>

        <div className="mt-3 text-xs text-slate-500">
          NB: le back doit renvoyer un fichier sur <code>/api/finance/export</code> (content-type CSV/PDF/Excel).
        </div>
      </div>
    </div>
  )
}
